import * as React from 'react';

export const useObjectURL = (file?: File): string | undefined => {
  const [objectURL, setObjectURL] = React.useState<string | undefined>(
    undefined
  );

  React.useEffect(() => {
    if (file) {
      const objectURL = URL.createObjectURL(file);
      setObjectURL(objectURL);
      return () => URL.revokeObjectURL(objectURL);
    }
    return;
  }, [file]);

  return objectURL;
};
